import { ContentChild, Directive, Input, TemplateRef } from '@angular/core';
import { TabsTriggerDirective } from './tabs-trigger.directive';
import { TabsContentDirective } from './tabs-content.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'black-tabs-item',
  standalone: false,
})
export class TabsItemDirective {
  @Input()
  name = '';

  @ContentChild(TabsTriggerDirective)
  tabsTrigger!: TabsTriggerDirective;

  @ContentChild(TabsContentDirective)
  tabscontent!: TabsContentDirective;
}
